var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-box"},_vm._l((_vm.itemList),function(item,index){return _c('div',{key:index,staticClass:"company-item hvr-grow-bg",class:{
      [`bg${index + 1}`]: true,
    }},[_c('div',{staticClass:"company-content-box"},[_c('div',{staticClass:"company-title"},[_vm._v(_vm._s(item.title))]),_vm._l((item.text),function(text){return _c('div',{key:text,staticClass:"company-text"},[_vm._v("\n        "+_vm._s(text)+"\n      ")])})],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }